(function () {
  'use strict';

  var INDEX_URL = (window.routes && window.routes.tt_fast_search_index) || window.ttFastSearchIndexUrl || '';
  var LIMIT = 12;
  var MIN_LETTER = 3;
  var cache = { items: null, loading: null };

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalize(value) {
    var text = String(value || '').toLowerCase().replace(/×/g, 'x');
    var prev;
    do {
      prev = text;
      text = text.replace(/(\d)\s*[x×]\s*(\d)/gi, '$1x$2');
    } while (text !== prev);
    text = text.replace(/(\d)\s*([a-z])\s*(\d)/gi, '$1$2$3');
    return text.replace(/[^a-z0-9.]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function compact(value) {
    return normalize(value).replace(/ /g, '');
  }

  function queryTokens(value) {
    var seen = {};
    var out = [];
    normalize(value).split(' ').forEach(function (part) {
      if (part.length < 2 || seen[part]) return;
      seen[part] = true;
      out.push(part);
    });
    return out;
  }

  function isSizeToken(token) {
    return /^\d{2,4}x\d/.test(token);
  }

  function shouldSearch(query) {
    var q = query.trim();
    if (!q) return false;
    if (/^\d/.test(q)) return compact(q).length >= 2;
    return q.length >= MIN_LETTER;
  }

  function haystack(item) {
    return normalize((item.t || '') + ' ' + (item.k || ''));
  }

  function scoreItem(item, query) {
    var tokens = queryTokens(query);
    if (!tokens.length) return 0;
    var hay = haystack(item);
    if (!hay) return 0;
    var qn = normalize(query);
    var qc = compact(query);
    var score = 0;
    var title = normalize(item.t || '');
    var extra = normalize(item.k || '');
    var parts = hay.split(' ');
    var i;
    for (i = 0; i < tokens.length; i++) {
      var token = tokens[i];
      if (parts.indexOf(token) !== -1 || extra.split(' ').indexOf(token) !== -1 || title.indexOf(token) !== -1) {
        score += 12;
      } else if (hay.indexOf(token) !== -1) {
        score += 10;
      } else if (isSizeToken(token) && parts.some(function (part) { return part.indexOf(token) === 0; })) {
        score += 9;
      } else {
        return 0;
      }
    }
    if (title === qn) score += 80;
    else if (title.indexOf(qn) === 0) score += 40;
    if (qc && extra.replace(/ /g, '').indexOf(qc) !== -1) score += 50;
    if (isSizeToken(qc) && hay.replace(/ /g, '').indexOf(qc) !== -1) score += 70;
    var wantsSteelPart = /\b(sprocket|idler|roller)\b/.test(qn);
    if (wantsSteelPart && /-fitment$/.test(String(item.h || ''))) score += 240;
    if (/track/i.test(item.y || '')) score += 8;
    return score;
  }

  function search(items, query) {
    var ranked = [];
    for (var i = 0; i < items.length; i++) {
      var score = scoreItem(items[i], query);
      if (score > 0) ranked.push({ score: score, item: items[i] });
    }
    ranked.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return String(a.item.t || '').localeCompare(String(b.item.t || ''));
    });
    return ranked.slice(0, LIMIT).map(function (row) { return row.item; });
  }

  function loadIndex() {
    if (cache.items) return Promise.resolve(cache.items);
    if (cache.loading) return cache.loading;
    if (!INDEX_URL) return Promise.resolve([]);
    cache.loading = fetch(INDEX_URL, { credentials: 'omit' })
      .then(function (res) { return res.ok ? res.json() : { items: [] }; })
      .then(function (data) {
        cache.items = (data && data.items) || [];
        return cache.items;
      })
      .catch(function () {
        cache.items = [];
        return cache.items;
      });
    return cache.loading;
  }

  function resultsHtml(query, items) {
    var searchUrl = '/search?q=' + encodeURIComponent(query);
    if (!items.length) {
      return '<div class="tt-fast-search" data-predictive-search-live-region-count-value>'
        + '<p class="tt-fast-search__empty">No products match <strong>' + esc(query) + '</strong>. Try a track size, OEM part #, or make and model.</p>'
        + '<a class="tt-fast-search__all" href="' + esc(searchUrl) + '">Search the full catalog</a>'
        + '</div>';
    }
    var rows = items.map(function (item) {
      var href = '/products/' + encodeURIComponent(item.h);
      var img = item.i
        ? '<img class="tt-fast-search__img" src="' + esc(item.i) + '" alt="" width="64" height="64" decoding="async">'
        : '<span class="tt-fast-search__ph" aria-hidden="true"></span>';
      return '<li><a class="tt-fast-search__row" href="' + href + '">'
        + img
        + '<span class="tt-fast-search__title">' + esc(item.t) + '</span>'
        + '</a></li>';
    }).join('');
    return '<div class="tt-fast-search" data-predictive-search-live-region-count-value>'
      + '<p class="tt-fast-search__count">' + items.length + ' matching products</p>'
      + '<ul class="tt-fast-search__list">' + rows + '</ul>'
      + '<a class="tt-fast-search__all" href="' + esc(searchUrl) + '">View all results for “' + esc(query) + '”</a>'
      + '</div>';
  }

  function renderInto(widget) {
    var query = widget.input ? widget.input.value.trim() : '';
    if (!shouldSearch(query)) {
      widget.closeResults(false);
      if (widget.searchResultsWrapper) widget.searchResultsWrapper.innerHTML = '';
      widget.removeAttribute('results');
      widget.removeAttribute('loading');
      return;
    }
    widget.setLiveRegionLoading();
    widget.showPlaceholder();
    loadIndex().then(function (items) {
      if (!widget.input || widget.input.value.trim() !== query) return;
      var hits = search(items, query);
      widget.renderSearchResults(resultsHtml(query, hits));
    });
  }

  function install() {
    var Ctor = customElements.get('predictive-search');
    if (!Ctor) {
      setTimeout(install, 30);
      return;
    }
    Ctor.prototype.getSearchResults = function () {
      renderInto(this);
    };
  }

  if (window.requestIdleCallback) {
    window.requestIdleCallback(function () { loadIndex(); }, { timeout: 1800 });
  } else {
    setTimeout(function () { loadIndex(); }, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }

  window.TTFastSearch = { normalize: normalize, search: search, loadIndex: loadIndex };
})();
